import PortalIdParser from 'PortalIdParser';
import { ProcessorPickerStatus } from '../types/processorPickerStatus';
import enviro from 'enviro';
const SETTINGS_BASE_URL = '/settings';
export const getRootUrl = () => `${SETTINGS_BASE_URL}/${PortalIdParser.get()}`;
export const getUsersAndTeamsURL = () => `${getRootUrl()}/users`;
export const termsOfServiceURL = 'https://legal.hubspot.com/payments-terms-of-use';
export const stripeIntegrationBetaTerms = 'https://legal.hubspot.com/stripe-integration-beta-terms';
export const PaymentMarketplaceURL = `/ecosystem/${PortalIdParser.get()}/marketplace/apps/apps-for-payments`;
export const userPermissionsKnowledgeURL = 'https://knowledge.hubspot.com/settings/edit-user-permissions';
export const getPaymentsURL = () => `${getRootUrl()}/sales/payments`;
export const getCommerceHomeUrl = () => `/commerce/${PortalIdParser.get()}`;
export const getCommerceHomeZeroStateUrl = () => `/commerce/${PortalIdParser.get()}/zero-state`;
export const getCommerceExpertLink = () => 'https://meetings.hubspot.com/commerce-specialist/in-app';
export const getCommerceExpertEmailFormLink = () => enviro.isProd() ? 'https://share.hsforms.com/1lG9PZxGGQ3-Ddu5TXRfiowbxo5v' : 'https://share.hsformsqa.com/1TeRbMoCtT_y2by__Fye5Vge9mlbk';
export const getPaymentsProcessorPickerOpenURL = () => `${getCommerceHomeUrl()}?processor-picker=${ProcessorPickerStatus.active}`;

// We can't use the enum from payments-enrollment-embed-lib for the query param
// value here. Could potentially look into moving those type definitions into
// growth-payments-core.
export const getCommerceHomeProcessorPickerIframeOpenURL = () => `${getCommerceHomeZeroStateUrl()}?paymentsEnrollment=processorPicker`;
export const getCommerceHomeBYOSIframeOpenURL = () => `${getCommerceHomeZeroStateUrl()}?paymentsEnrollment=stripe`;
export const getCommerceHomeHSPIframeOpenURL = () => `${getCommerceHomeZeroStateUrl()}?paymentsEnrollment=native`;
export const getPaymentLinksURL = () => `/payment-links/${PortalIdParser.get()}`;
export const getSharePaymentsUsePaymentLinkOrQuote = () => `/share-payments/${PortalIdParser.get()}/usePaymentLinkOrQuote`;
export const getPaymentLinksTemplateURL = template => {
  const baseUrl = getPaymentLinksURL();
  const templateQuery = template ? `?selectedTemplate=${template}` : '';
  return `${baseUrl}/templates${templateQuery}`;
};
export const getQuotesURL = () => `/quotes/${PortalIdParser.get()}`;
export const getCreateQuoteURL = () => `${getQuotesURL()}/edit/new`;
export const getCreateCPQQuoteURL = () => `${getQuotesURL()}/?create=cpq`;
export const getInvoicesURL = () => `/invoices/${PortalIdParser.get()}`;
export const getCreateInvoicesURL = () => `${getInvoicesURL()}/invoice/create`;
export const getPaymentsPaywallURL = () => {
  return `/upgrade/${PortalIdParser.get()}/payments`;
};
export const getProductsURL = () => {
  return `/contacts/${PortalIdParser.get()}/objects/0-7`;
};
export const getDealsURL = () => {
  return `/contacts/${PortalIdParser.get()}/objects/0-3/views/all/list`;
};
export const getSubscriptionsURL = () => `/contacts/${PortalIdParser.get()}/objects/0-69/views/all/list`;
export const getBillingWizardURL = () => `/billing-wizard-ui/${PortalIdParser.get()}/create`;
export const getCommerceHubPricingPageURL = () => `/pricing/${PortalIdParser.get()}/commerce`;
export const getCommerceHubMarketingPageURL = () => 'https://www.hubspot.com/products/commerce?hubs_content=www.hubspot.com/&hubs_content-cta=nav-software-commerce';
export const getPaymentsIndexURL = () => `/contacts/${PortalIdParser.get()}/objects/0-101/views/all/list`;
export const getContractsIndexURL = () => `/contacts/${PortalIdParser.get()}/objects/0-721/views/all/list`;
export const getAccountBrandingURL = () => `${SETTINGS_BASE_URL}/${PortalIdParser.get()}/account-defaults/branding`;
export const getWebsitesURL = () => `/website/${PortalIdParser.get()}/pages/site/all`;
export const getInvoicesSettingsUrl = () => `${getRootUrl()}/sales/invoices`;
export const getPaymentLinksSettingsUrl = () => `${getRootUrl()}/sales/payment-links`;
export const getQuotesSettingsUrl = () => `${getRootUrl()}/sales/quotes`;
export const getProductsSettingsUrl = () => `${getRootUrl()}/sales/products`;
export const getSubscriptionsSettingsUrl = () => `${getRootUrl()}/sales/subscriptions`;
export const getCPQUpgradePageURL = () => `/pricing/${PortalIdParser.get()}/upgrade/locked-nav-item?upgradeSource=cpq-quotes-locked-nav-item`;
export const getCPQLegacyAccessUpgradePageURL = () => `/pricing/${PortalIdParser.get()}/upgrade/locked-nav-item?upgradeSource=cpq-quotes-locked-nav-item-legacy-quotes-access`;
export const getClosingAgentUpgradePageURL = () => `/pricing/${PortalIdParser.get()}/upgrade/locked-nav-item?upgradeSource=closing-agent-locked-nav-item`;